import { SwapOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useSwitchUser } from './hooks';
import SwitchUserPopup from './SwitchUserPopup';

const SwitchUser = () => {
  const [t] = useTranslation();
  const {
    actions: { setVisible },
    data: { isVisible },
  } = useSwitchUser();

  const toggleShowPopup = useCallback(() => {
    setVisible(!isVisible);
  }, [isVisible, setVisible]);

  return (
    <>
      <Button
        variant={'link'}
        color={'default'}
        shape="circle"
        icon={<SwapOutlined />}
        onClick={toggleShowPopup}
        aria-label={t('SWITCH_USER')}
      />
      <SwitchUserPopup isVisible={isVisible} setVisible={setVisible} />
    </>
  );
};

export default React.memo(SwitchUser);
